import { RecordValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, validatePayload, } from '../../../../utils/validate-payload.js';
import { facetValueDefinition } from '../../../facets/facet-set/facet-set-validate-payload.js';
export const toggleSelectLocationFacetValue = createAction('commerce/facets/locationFacet/toggleSelectValue', (payload) => validatePayload(payload, {
    facetId: requiredNonEmptyString,
    selection: new RecordValue({ values: facetValueDefinition }),
}));
